import { UserResponse } from '../../api/models/user-response';

const PLATFORM_ADMIN_ROLES = new Set(['ADMIN', 'SUPER_ADMIN']);
const CUSTOMER_ADMIN_ROLE = 'CUSTOMER_ADMIN';

export function userHasRole(user: UserResponse | null | undefined, roleName: string): boolean {
  return user?.roles?.some((role) => role.name === roleName) ?? false;
}

export function isPlatformAdmin(user: UserResponse | null | undefined): boolean {
  return user?.roles?.some((role) => PLATFORM_ADMIN_ROLES.has(role.name ?? '')) ?? false;
}

/** Organization owner / account admin — can invite members and assign roles. */
export function isCustomerAdmin(user: UserResponse | null | undefined): boolean {
  return isPlatformAdmin(user) || userHasRole(user, CUSTOMER_ADMIN_ROLE);
}

export function canManageTeam(user: UserResponse | null | undefined): boolean {
  return isCustomerAdmin(user);
}

export function getPrimaryRoleName(user: UserResponse | null | undefined): string | undefined {
  return user?.roles?.[0]?.name;
}
